import { render, staticRenderFns } from "./EmailIcon.vue?vue&type=template&id=0317af44&"
import script from "./EmailIcon.vue?vue&type=script&lang=ts&"
export * from "./EmailIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports